module.exports = __webpack_public_path__ + "img/Flag_of_Dominica.110a48b9.svg";